import axios from 'axios';

export default class InfiniteScroll {
  constructor($el) {
    this.$el = $el;
    this.$list = $el.find('.list');
    this.$loading = $el.find('.loading');
    this.url = new URL($el.data('url'));
    const extraParameters = new URLSearchParams($el.data('parameters'));
    const queryStringParameters = new URLSearchParams(window.location.search);
    this.parameters = new URLSearchParams({
      ...Object.fromEntries(extraParameters),
      ...Object.fromEntries(queryStringParameters),
    });
    this.parameters.set('page', 1);
    this.isLoading = undefined;
    this.intersectionObserver = new IntersectionObserver(() => this.loadMore());
    this.intersectionObserver.observe(this.$loading[0]);
  }
  loadMore() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.$loading.addClass('active');
    axios
      .get(this.getSearchUrl())
      .then(response => this.handleResponse(response))
      .finally(() => {
        this.isLoading = false;
        this.$loading.removeClass('active');
      });
  }
  handleResponse({ data }) {
    this.$list.append(data.html);
    this.parameters.set('page', data.next_page);

    if (!data.has_next_page) {
      this.intersectionObserver.disconnect();
      this.$loading.remove();
    }
  }
  getSearchUrl() {
    const url = this.url;
    url.search = this.parameters.toString();
    return url.toString();
  }
}
